module.exports = __webpack_public_path__ + "static/media/progman_4.06ac0d22.ico";